import {Component} from '@angular/core';
import {ModalController, NavController, NavParams} from 'ionic-angular';


import {LicitacaoService} from '../../../../providers/licitacao-service';
import {AlertService} from '../../../../providers/alert-service';
import {MenuService} from '../../../../providers/menu-service';
import {ModulosController} from '../../modulos-controller';
import {UsuarioService} from '../../../../providers/usuario-service';
import {GestaoPcaService} from '../../../../providers/gestao-pca-service';

@Component({
    selector: 'page-modalidade-versus-contratado',
    templateUrl: 'modalidade-versus-contratado.html',
    providers: [
        LicitacaoService
    ]
})
export class ModalidadeVersusContratadoPage extends ModulosController {
    listaDados: any = [];
    listaDadosConvite: any = [];
    listaDadosTomada: any = [];
    listaDadosConcorrencia: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "65";

    pageTomada: number = 1;
    pageConvite: number = 1;
    pageConcorrencia: number = 1;

    order1: string = 'numeroContrato';
    reverse1: boolean = true;

    order2: string = 'numeroContrato';
    reverse2: boolean = true;

    order3: string = 'numeroContrato';
    reverse3: boolean = true;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public licitacaoService: LicitacaoService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        this.setModuloId(7);
    }

    setOrder1(value: string) {
        if (this.order1 === value) {
            this.reverse1 = false;
            this.order1 = "-" + value;
        } else {
            this.reverse1 = true;
            this.order1 = value;
        }
    }

    setOrder2(value: string) {
        if (this.order2 === value) {
            this.reverse2 = false;
            this.order2 = "-" + value;
        } else {
            this.reverse2 = true;
            this.order2 = value;
        }
    }

    setOrder3(value: string) {
        if (this.order3 === value) {
            this.reverse3 = false;
            this.order3 = "-" + value;
        } else {
            this.reverse3 = true;
            this.order3 = value;
        }
    }

    carregarDados() {
        this.licitacaoService.obterModalidadeVersusContratado().subscribe(data => {
            this.listaDados = data;
            this.listaDadosConvite = this.listaDados.analises1;
            this.listaDadosTomada = this.listaDados.analises2;
            this.listaDadosConcorrencia = this.listaDados.analises3;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaLicitacao() {
        this.menuService.redirecionarPagina(this.licitacaoService.obterIdPaginaLicitacao());
    }

    salvarFlagIncluir(enviarMensagem = true) {
        this.loading = true;
        this.listaDados.resumoAnalise = this.capitalize(this.listaDados.resumoAnalise);
        this.licitacaoService.salvarAnalisesLicitacaoModelo(this.listaDados, this.idSecaoPagina).subscribe(data => {
            if (enviarMensagem) {
                this.alertService.mostraAlerta("", "Salvo com sucesso.");
                this.loading = false;
            } else {
                let idAnalise = "";
                idAnalise = this.listaDados.idModuloAnalise;

                this.licitacaoService.submeterAnaliseNoCertificado(idAnalise, this.listaDados, this.idSecaoPagina).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaLicitacao();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
            this.loading = false;
        })
    }

    submeterNoCertificado() {
        let idAnalise = "";
        this.loading = true;
        if (this.listaDados.resumoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resumoAnalise == null || this.listaDados.resumoAnalise == undefined || !this.listaDados.resumoAnalise) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                this.salvarFlagIncluir(false);                
            }
        }
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    formatarZeroEsquerda(valor) {
        return valor.replace(/^0+(?!\.|$)/, '');
    }

    capitalize(str) {
        let retorno = "";
    
        if (str) {
          retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }
    
        return retorno;
      }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/licitacao/modalidade-versus-contratado/modalidade-versus-contratado.ts